import React from 'react';
import { Pagination } from '~/components/Pagination';
import { ProviderTile, SuggestProviderModal } from '~/components/Patient/Referrals';
import { SpinnerOverlay } from '~/components/SpinnerOverlay';
import { PaginationType } from '~/util';
import { ProviderType } from '~/util/providerUtils';

export interface ProviderResultsProps {
    hasSearched: boolean;
    loading: boolean;
    providerList: ProviderType[];
    pagination: PaginationType;
    updatePagination: (pagination: PaginationType) => void;
    planCode: string | undefined;
}

export function ProviderResults({
    hasSearched,
    loading,
    providerList,
    pagination,
    updatePagination,
    planCode,
}: ProviderResultsProps) {
    if (!hasSearched) return null;

    return (
        <div className="position-relative">
            <SpinnerOverlay show={loading} />
            <div className="patient-gaps-container">
                <div className="row">
                    {providerList.length === 0 && (
                        <div className="text-center mt-5 mb-5">
                            There are no results
                            <br />
                            for your current search
                        </div>
                    )}
                    {providerList.map((provider) => (
                        <ProviderTile
                            key={`${provider.entityType}-${provider.id}`}
                            provider={provider}
                            planCode={planCode}
                            selectable
                        />
                    ))}
                </div>
                <div className="row">
                    <div className="col text-end my-2 me-5">
                        <SuggestProviderModal planCode={planCode} />
                    </div>
                </div>
            </div>
            {providerList.length > 0 && (
                <Pagination
                    pagination={pagination}
                    updatePagination={updatePagination}
                    totalNumLimit={10000}
                />
            )}
        </div>
    );
}
